import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { atlas } from "../../lib/sdk";
import { inicioDoBanco } from "./nav";

/**
 * `/banco` sem tela: leva a Visao do mes quem opera beneficios e a Visao geral
 * quem so' opera credito (#314). Espera o `me` — e' ele que traz o modo do
 * credor. Se o `me` falhar, cai na Visao geral, o comportamento de antes do modo.
 */
export function BancoInicio() {
  const meQ = useQuery({ queryKey: ["banco", "me"], queryFn: () => atlas.banco.me(), staleTime: 60_000 });
  if (meQ.isPending) return null;
  return <Navigate to={inicioDoBanco(meQ.data?.modo_portal)} replace />;
}
